import React from 'react';
import styled from '@benzinga/themetron';
import { News, StoryObject } from '@benzinga/basic-news-manager';
import type { DeviceType } from '@benzinga/device-utils';
import { appEnvironment, appName } from '@benzinga/utils';
import { FeaturedSection, FeaturedSectionIndia, NewsSection } from '@benzinga/news';

export interface NewsFeaturedSectionProps {
  attrs: {
    data?: {
      display_more_featured_news?: string;
      featuredNews?: News[] | StoryObject[];
    };
  };
  deviceType?: DeviceType;
}

export const NewsFeaturedSectionBlock: React.FC<NewsFeaturedSectionProps> = ({ attrs, deviceType }) => {
  const displayMoreFeaturedNews = attrs?.data?.display_more_featured_news;
  const news = attrs?.data?.featuredNews;
  const isIndiaApp = appEnvironment().isApp(appName.india);

  return (
    <NewsFeaturedSectionWrapper>
      {Array.isArray(news) && (
        <div className="news-featured-section-block">
          {isIndiaApp ? (
            <FeaturedSectionIndia nodes={news} />
          ) : (
            <FeaturedSection deviceType={deviceType} nodes={news} />
          )}
          <hr className="my-4" />
          {displayMoreFeaturedNews && news.length >= 7 && (
            <div>
              <NewsSection dataActionPrefix="Featured Stories - Extended" nodes={news.slice(3, 7)} />
            </div>
          )}
        </div>
      )}
    </NewsFeaturedSectionWrapper>
  );
};

export const NewsFeaturedSectionWrapper = styled.div`
  margin: 1rem auto;
`;
